import { render, staticRenderFns } from "./EUDRSettings.vue?vue&type=template&id=964c3d9e&scoped=true"
import script from "./EUDRSettings.vue?vue&type=script&lang=js"
export * from "./EUDRSettings.vue?vue&type=script&lang=js"
import style0 from "./EUDRSettings.vue?vue&type=style&index=0&id=964c3d9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964c3d9e",
  null
  
)

export default component.exports